var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"va-badge mr-2",class:_vm.badgeClass,style:(_vm.badgeStyle)},[_c('div',{staticClass:"va-badge__content d-flex"},[_c('div',{staticClass:"va-badge__content__title flex-center"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }